import PropTypes from 'prop-types';
import React from 'react';
import { UX2 } from '@wsb/guac-widget-core';
import { RouteHandler, ShopViewConstants } from '@wsb/guac-widget-shared/lib/common/ols-core/core-bundle';

class LineItemsRemoved extends React.Component {
  constructor() {
    super(...arguments);
    this.handleProductDetailClick = this.handleProductDetailClick.bind(this);
  }

  handleProductDetailClick(slug) {
    RouteHandler.navigate(ShopViewConstants.PRODUCT_DETAIL, { slug: slug });
  }

  render() {
    const translate = this.context.translate || (() => {});
    const { lineItems } = this.props;
    const { Block, Link } = UX2.Element;
    const { Grid, Grid: { Cell } } = UX2.Component;
    const styles = {
      marginBottom: 'medium',
      paddingVertical: 'small',
      paddingHorizontal: 'medium',
      backgroundColor: 'section',
      fontColor: 'section',
      borderRadius: 'small'
    };

    if (!lineItems || !lineItems.length) {
      return null;
    }

    const listItems = lineItems.map(({ name, slug }) =>
      <Block style={{ marginTop: 'xsmall' }}>
        <Link onClick={ this.handleProductDetailClick.bind(null, slug) } href='javascript:;' children={ name } />
      </Block>
    );

    return (
      <Grid size={ 12 }>
        <Cell xs={ 12 } sm={ 10 } pushSm={ 1 }>
          <Block section='alt' style={ styles }>
            <Block children={ translate('cart.items_changed_price') } />
            {listItems}
          </Block>
        </Cell>
      </Grid>
    );
  }
}

LineItemsRemoved.defaultProps = {
  lineItems: []
};

LineItemsRemoved.propTypes = {
  lineItems: PropTypes.array.isRequired
};

LineItemsRemoved.contextTypes = {
  translate: PropTypes.func
};

export default LineItemsRemoved;
